export const iconFontAwesomeMapsShower = (
	<i className="fa-solid fa-shower"></i>
);
